if (!customElements.get('featured-collection-content')) {
  class FeaturedCollectionContent extends HTMLElement {
    constructor() {
      super();

      this.slider = this.closest('default-slider');
      this.loader = this.slider.querySelector('[data-loader]');
      this.productsWrapper = this.querySelector('[data-featured-products-collection-content]');
      this.collectionLinks = this.querySelectorAll('[data-featured-products-collection-link]');

      if (this.collectionLinks && this.productsWrapper && this.slider) {
        this.collectionLinks.forEach(link => link.addEventListener('click', this.loadProducts.bind(this)))
      }
    }

    loadProducts(event) {
      event.preventDefault();
      const url = event.target.href;

      // destroy the swiper
      this.slider.swiperElement.classList.add('featured-products-collection__swiper--hidden');
      this.slider.swiperInstance.destroy();

      // update the classes
      this.querySelector('.featured-products-collection__nav-item--active').classList.add('underlined-link');
      this.querySelector('.featured-products-collection__nav-item--active').classList.remove('featured-products-collection__nav-item--active');
      event.target.classList.add('featured-products-collection__nav-item--active');
      event.target.classList.remove('underlined-link');

      // show loader
      this.loader?.classList.remove('hidden');

      // get the new content
      fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html').querySelector('#products');
        this.productsWrapper.innerHTML = parsedHTML.innerHTML;
      })
      .then(() => {
        // init swiper on new content and show the slider
        this.slider.init();

        // hide loader and show slider
        this.slider.swiperElement.classList.remove('featured-products-collection__swiper--hidden');
        this.loader?.classList.add('hidden');
      })
      .catch((error) => {
        console.error(error);
      });
    }
  }

  window.FeaturedCollectionContent = FeaturedCollectionContent;
  customElements.define('featured-collection-content', FeaturedCollectionContent);
}
